import { render, staticRenderFns } from "./CompeteResult.vue?vue&type=template&id=95716598&scoped=true&"
import script from "./CompeteResult.vue?vue&type=script&lang=js&"
export * from "./CompeteResult.vue?vue&type=script&lang=js&"
import style0 from "./CompeteResult.vue?vue&type=style&index=0&id=95716598&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95716598",
  null
  
)

export default component.exports